"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditInformationSourceId = exports.availablePaymentMethods = exports.isCreditPaymentMethod = exports.isConsortiumLender = exports.isConsortiumAffiliated = void 0;
const EConsortiumCgpStatus_1 = require("../enums/Consortium/EConsortiumCgpStatus");
const EConsortiumLender_1 = require("../enums/Consortium/EConsortiumLender");
const EPaymentMethod_1 = require("../enums/ProductSubscribed/EPaymentMethod");
function isConsortiumAffiliated(status) {
    return status === EConsortiumCgpStatus_1.EConsortiumCgpStatus.valide;
}
exports.isConsortiumAffiliated = isConsortiumAffiliated;
function isConsortiumLender(value) {
    return value === EConsortiumLender_1.EConsortiumLender.CFCAL || value === EConsortiumLender_1.EConsortiumLender.CACF;
}
exports.isConsortiumLender = isConsortiumLender;
function isCreditPaymentMethod(method) {
    return method === EPaymentMethod_1.EPaymentMethod.CREDIT || method === EPaymentMethod_1.EPaymentMethod.CREDIT_CONSORTIUM;
}
exports.isCreditPaymentMethod = isCreditPaymentMethod;
function availablePaymentMethods(methods, isAffiliated) {
    return methods.filter((method) => method !== EPaymentMethod_1.EPaymentMethod.CREDIT_CONSORTIUM || isAffiliated);
}
exports.availablePaymentMethods = availablePaymentMethods;
function creditInformationSourceId(products, target, useSameModeInformation) {
    if (!useSameModeInformation || !isCreditPaymentMethod(target.paymentMethod))
        return target.id;
    return products.find((product) => product.paymentMethod === target.paymentMethod)?.id ?? target.id;
}
exports.creditInformationSourceId = creditInformationSourceId;
